module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-zh-TW.be3d12e9.jpg";